import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import financePriceDisplayMultiStyles from './financePriceDisplayMultiStyles';
import Price from '../../../../../../common/components/presentation/Price';
import { IFinanceQuote } from '../../../../../../common/model/IFinanceQuote';
import InformativeSectionContainer from '../../../../customiseContainer/footer/PriceSection/informativeSection/InformativeSectionContainer';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import CalculateButton from '../../../financeElements/calculateButton/CalculateButton';
import { IPriceDisplay } from '../../../../../../common/model/IPlatformConfig';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IFinancePriceDisplayMultiProps {
  primaryFinanceQuote: Partial<IFinanceQuote>;
  secondaryCurrencyQuote: Partial<IFinanceQuote>;
  isDisabled: boolean;
  priceDisplay: IPriceDisplay;
  onIndicativeClick: () => void;
  onFinanceCalculate: () => void;
}

const FinancePriceDisplayMulti: FC<IFinancePriceDisplayMultiProps> = ({
  secondaryCurrencyQuote,
  primaryFinanceQuote,
  isDisabled,
  priceDisplay,
  onIndicativeClick,
  onFinanceCalculate,
}) => {
  const {
    financePriceContainer,
    financePrice,
    priceContainer,
    multiCurrencyPriceContainer,
    priceGroup,
    orLabel,
    priceLabel,
    informativeSection,
    cta,
  } = financePriceDisplayMultiStyles();

  return (
    <Box className={financePriceContainer} data-test="container:finance-multicurrency">
      <Box className={informativeSection}>
        <InformativeSectionContainer />
      </Box>
      <Box className={clsx([priceContainer, multiCurrencyPriceContainer])}>
        <Box className={priceGroup}>
          <Price
            component="span"
            className={financePrice}
            price={primaryFinanceQuote.monthlyPayment}
            currency={priceDisplay.primary.currency}
            decimals={priceDisplay.finance?.decimalScale ?? 2}
            data-test="text:price:primary-finance-price-value"
          />
          <Typography data-test="text:price:or" className={orLabel}>
            <Translation id="spc.configuratorSummary.or" />
          </Typography>
          <Price
            component="span"
            className={financePrice}
            price={secondaryCurrencyQuote.monthlyPayment}
            currency={priceDisplay.secondary.currency}
            decimals={priceDisplay.finance?.decimalScale ?? 2}
            data-test="text:price:secondary-finance-price-value"
          />
        </Box>
        <Typography className={priceLabel} variant={'helpingText'} data-test={'text:price:label'}>
          <Translation id={'spc.customise.repayment'} />
          <IndicativeNumber
            dataTest="repayment_value"
            displayNumber={<Translation id="spc.customise.indicative.repayment" />}
            onClick={onIndicativeClick}
          />
        </Typography>
      </Box>
      <Box className={cta}>
        <CalculateButton disabled={isDisabled} onFinanceCalculate={onFinanceCalculate} />
      </Box>
    </Box>
  );
};

export default FinancePriceDisplayMulti;
